import React, { useMemo } from 'react';
import { Box, SxProps, Theme, useTheme } from '@mui/material';

import { useMarkdownParser } from './useMarkdownParser';
import { getMarkdownContentStyles } from './styles';

interface MarkdownContentProps {
  content: string;
  sx?: SxProps<Theme>;
  variant?: 'default' | 'embedded';
}

export const MarkdownContent: React.FC<MarkdownContentProps> = ({
  content,
  sx,
  variant = 'default',
}) => {
  const theme = useTheme();
  const mdParser = useMarkdownParser();

  const html = useMemo(() => mdParser.render(content), [content, mdParser]);

  return (
    <Box
      className="custom-html-style"
      sx={[
        getMarkdownContentStyles(theme, { variant }),
        ...(sx ? (Array.isArray(sx) ? sx : [sx]) : []),
      ]}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
